import { Navbar } from "./Navbar";
import { Footer } from "./Footer";

export const Layout = ({ children, navItems = [] }) => {
  return (
    <div className="min-h-screen flex flex-col bg-its-teal">
      <Navbar navItems={navItems} />
      <main className="flex-grow">{children}</main>
      <Footer />
    </div>
  );
};
